import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=045c93bc&"
import script from "./Timestamp.vue?vue&type=script&lang=js&"
export * from "./Timestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports